import svg4everybody from 'svg4everybody';

svg4everybody();
// open-sing-up-popup

const singupCheckboxLabel = document.querySelector('.js--singup-checkbox-label');
const singupPopupHeading = document.querySelector('.js--singup-popup-heading');
const openSingUpPopup = document.querySelectorAll('.js--open-sing-up-popup');
const hamburgerMenuNav = document.querySelector('#hamburger-menu-nav');
const hamburgerMenuNavBackdrop = document.querySelector('.hamburger-menu-nav-backdrop');
const menuNavSingInLink = document.querySelector('.js--menu-nav-sing-in-link');
const indexHeaderSingInForm = document.querySelector('.js--index-header-sing-in-form');
const indexHeaderSingInFormInputEmail = document.querySelector(
  '.js--index-header-sing-in-form-input-email'
);
const tplMenuNavListItem = document.querySelectorAll('.js--tpl-menu-nav-list-item');

[].forEach.call(openSingUpPopup, el => {
  el.addEventListener('click', function() {
    if (singupCheckboxLabel) {
      singupPopupHeading.innerHTML = el.innerHTML;
      singupCheckboxLabel.click();
    }
  });
});

if (menuNavSingInLink) {
  menuNavSingInLink.addEventListener('click', function(e) {
    if (indexHeaderSingInFormInputEmail) {
      e.preventDefault();
      indexHeaderSingInFormInputEmail.focus();
      indexHeaderSingInForm.classList.add('splash-form');
    }
  });
}

[].forEach.call(tplMenuNavListItem, el => {
  el.addEventListener('click', function() {
    if (hamburgerMenuNav) {
      hamburgerMenuNav.checked = false;
      hamburgerMenuNavBackdrop.style.display = tplMenuNavListItem.checked ? 'block' : 'none';
    }
  });
});

hamburgerMenuNav.addEventListener('click', function() {
  hamburgerMenuNavBackdrop.style.display = hamburgerMenuNav.checked ? 'block' : 'none';
});

hamburgerMenuNavBackdrop.addEventListener('click', function() {
  hamburgerMenuNav.checked = false;
  hamburgerMenuNavBackdrop.style.display = hamburgerMenuNavBackdrop.checked ? 'block' : 'none';
});

function getCookie(name) {
  const matches = document.cookie.match(
    new RegExp(`(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`)
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

const {
  userID,
  organizationsDataForCalendars = [],
  _uri,
  _model,
  _action,
  _organization,
  timeZoneOffset
} = window.serverData;

let organizationsCalendars = JSON.parse(getCookie('organizationsCalendars') || '{}');
let organizationsCalendarsJSON = '';
const date = new Date();
function rememberOrganizationsCalendars(organizationsCals) {
  const updatedCalendars = {
    ...organizationsCals,
    ...organizationsCalendars,
    [`organization-${_organization.id}`]: _action
  };
  const updatedCalendarsJSON = JSON.stringify(updatedCalendars);
  date.setDate(date.getDate() + 30);
  document.cookie = `organizationsCalendars=${updatedCalendarsJSON}; path=/; expires=${date.toUTCString()}`;
  return updatedCalendars;
}

function genereteAddEventButton() {
  const holdLastOrganization = getCookie(`holdLastOrganization${userID}`);
  let calendarView = 'month';
  let link = '';

  if (_model === 'calendar') {
    organizationsCalendars = rememberOrganizationsCalendars();
  }

  if (!organizationsDataForCalendars) {
    return link;
  }

  for (let i = 0; i < organizationsDataForCalendars.length; i++) {
    if (organizationsDataForCalendars[i].unique === holdLastOrganization) {
      if (organizationsCalendars[`organization-${organizationsDataForCalendars[i].id}`]) {
        calendarView =
          organizationsCalendars[`organization-${organizationsDataForCalendars[i].id}`];
        if (calendarView === 'pilot') {
          calendarView = 'report';
        }
      }
      break;
    }
  }

  if (holdLastOrganization) {
    const dateStart = new Date();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const timezoneOffset = date.getTimezoneOffset() * 60 - timeZoneOffset;
    const unixDate = parseInt(date.getTime() / 1000 - timezoneOffset, 10);

    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);

    if (minutes < 30) {
      minutes = 30;
    } else {
      minutes = 0;
      hours = hours + 1;
    }
    dateStart.setHours(hours);
    dateStart.setMinutes(minutes);
    dateStart.setSeconds(0);

    const unixDateStart = parseInt(dateStart.getTime() / 1000, 10);

    if (_model === 'calendar') {
      link = window.location.origin + window.location.pathname;
    } else {
      link = `${_uri}/org/${holdLastOrganization}/calendar/${calendarView}/`;
    }

    link += `#/!?day=${unixDate}&org=${holdLastOrganization}&action=event-add&startTime=${unixDateStart}`;
  }
  return link;
}

const addButton = document.getElementsByClassName('add-event-button');
const link = genereteAddEventButton();

if (addButton[0]) {
  if (link !== '') {
    addButton[0].setAttribute('href', link);
  } else {
    addButton[0].style.display = 'none';
  }
}

organizationsCalendarsJSON = getCookie('organizationsCalendars');
if (organizationsCalendarsJSON !== undefined && organizationsCalendarsJSON !== '') {
  organizationsCalendars = JSON.parse(organizationsCalendarsJSON);
}

for (const key in organizationsCalendars) {
  if (organizationsCalendars.hasOwnProperty(key)) {
    const itemCalendar = document.getElementsByClassName(
      `${key}-${organizationsCalendars[key]}`
    )[0];
    const item = document.getElementById(key);
    if (itemCalendar && item) {
      item.setAttribute('href', itemCalendar.getAttribute('href'));

      [].forEach.call(document.querySelectorAll(`.${key}-month`), el => {
        el.classList.remove('visible-dropdown-btn');
      });

      itemCalendar.classList.add('visible-dropdown-btn');
    }
  }
}

// $(".fancybox-content, .zoom-image").fancybox({
//   width       : '700',
//   height      : '80%',
//   fitToView   : false,
//   autoSize    : false,
//   closeClick  : true,
//   openEffect  : 'none',
//   closeEffect : 'none'
// });

// $('.fancybox-media').fancybox({
//   openEffect  : 'none',
//   closeEffect : 'none',
//   helpers : {
//     media : {}
//   }
// });
